<template>
    <div class="login-container">
        <zm-form class="login-form" autoComplete="on" label-position="left" label-width="90px">
            <zm-form-item>
                <h1>403</h1>
                <h2>NO PERMISSION</h2>
            </zm-form-item>
        </zm-form>
        <div class="footer">
            <p>© 2020 Zoom Video Communications, Inc. All rights reserved.</p>
        </div>
    </div>
</template>
<script>
import { getMenuList } from '@/api/permission'
export default {
    name: 'nopermission',
    created () {
        getMenuList()
    }
}
</script>
<style>
.login-form h1 {
    font-size: 40px;
    color: #b4b4b4;
}
.login-form h2 {
    font-size: 24px;
    color: #b4b4b4;
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
.footer {
    text-align: center;
    color: #eee;
    font-size: 14px;
    height: 30px;
    width: 100%;
    bottom: 0;
    border-top: 1px solid #889aa4;
    position: fixed;
    background-color: #363a40;
    z-index: 1002;
    padding-bottom: 12px;
}
.title-login {
  font-size: 24px;
}
$bg:#363a40;
$dark_gray:#889aa4;
$light_gray:#eee;
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: $bg;
  text-align: left;
  color: #b4b4b4;
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 420px;
    padding: 35px 35px 15px 35px;
    margin: calc((100vh - 300px) / 2) auto;
  }
}
</style>
